import React, { useState } from 'react';
import Button from '../common-ui/button/Button';
import InputField from '../common-ui/input-field/InputField';
import './CustomerFeedBack.scss';

const CustomerFeedBack = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    satisfaction: null as number | null,
    purpose: '',
    foundWhatLookingFor: '',
    additionalFeedback: ''
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleRatingSelect = (rating: number) => {
    setFormData(prev => ({ ...prev, satisfaction: rating }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Feedback submitted:', formData);
    setIsSubmitted(true);
  };

  const handleClose = () => {
    setIsOpen(false);
    setIsSubmitted(false);
    setFormData({
      satisfaction: null,
      purpose: '',
      foundWhatLookingFor: '',
      additionalFeedback: ''
    });
  };

  if (!isOpen) {
    return (
      <div className="feedback-button-container">
        <Button 
          text="Feedback"
          onClick={() => setIsOpen(true)}
          className="feedback-toggle-button"
        />
      </div>
    );
  }

  if (isSubmitted) {
    return (
      <div className="feedback-widget">
        <div className="feedback-header">
          <h3>Thank You!</h3>
          <button className="close-button" onClick={handleClose}>×</button>
        </div>
        <div className="feedback-body">
          <p>We appreciate your feedback!</p>
          <Button
            text="Close"
            onClick={handleClose}
            className="submit-button"
          />
        </div>
      </div>
    );
  }

  return (
    <div className="feedback-widget">
      <div className="feedback-header">
        <h3>We Value Your Feedback</h3>
        <button className="close-button" onClick={handleClose}>×</button>
      </div>
      <form onSubmit={handleSubmit} className="feedback-form">
        <div className="form-group">
          <label className="question-label">
            Overall, how satisfied are you with the website? *
          </label>
          <div className="rating-scale">
            <div className="scale-numbers">
              {[...Array(11)].map((_, i) => (
                <span key={i} className="scale-number">{i}</span>
              ))}
            </div>
            <div className="scale-bars">
              {[...Array(11)].map((_, i) => (
                <div
                  key={i}
                  className={`scale-bar ${formData.satisfaction === i ? 'selected' : ''}`}
                  onClick={() => handleRatingSelect(i)}
                />
              ))}
            </div>
            <div className="scale-labels">
              <span>Not At All Satisfied</span>
              <span>Extremely Satisfied</span>
            </div>
          </div>
        </div>

        <div className="form-group">
          <InputField
            type="text"
            name="purpose"
            value={formData.purpose}
            onChange={handleInputChange}
            label="What was the purpose of your visit today? *"
            required
          />
        </div>

        <div className="form-group">
          <label className="question-label">
            Did you find what you were looking for? *
          </label>
          <div className="radio-options">
            <label className="radio-option">
              <input
                type="radio"
                name="foundWhatLookingFor"
                value="Yes"
                checked={formData.foundWhatLookingFor === 'Yes'}
                onChange={handleInputChange}
                required
              />
              <span className="radio-label">Yes</span>
            </label>
            <label className="radio-option">
              <input
                type="radio"
                name="foundWhatLookingFor"
                value="No"
                checked={formData.foundWhatLookingFor === 'No'}
                onChange={handleInputChange}
              />
              <span className="radio-label">No</span>
            </label>
            <label className="radio-option">
              <input
                type="radio"
                name="foundWhatLookingFor"
                value="Not finished"
                checked={formData.foundWhatLookingFor === 'Not finished'}
                onChange={handleInputChange}
              />
              <span className="radio-label">Not finished</span>
            </label>
          </div>
        </div>

        {formData.satisfaction !== null && (
          <div className="form-group">
            <InputField
              name="additionalFeedback"
              value={formData.additionalFeedback}
              onChange={handleInputChange}
              label="Additional feedback (optional)"
              // multiline
              // rows={4}
            />
          </div>
        )}

        <div className="form-footer">
          <Button
            text="Close"
            onClick={handleClose}
            type="button"
            className="secondary-button"
          />
          <Button
            text="Submit"
            type="submit"
            className="submit-button"
            disabled={!formData.satisfaction || !formData.purpose || !formData.foundWhatLookingFor}
          />
          <div className="powered-by">
            <span>Powered by</span>
            <strong>MFSYS</strong>
          </div>
        </div>
      </form>
    </div>
  );
};

export default CustomerFeedBack;